import { Component, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Component({
  selector: 'app-customer-refresh',
  templateUrl: './customer-refresh.component.html',
  styleUrls: ['./customer-refresh.component.css']
})
export class CustomerRefreshComponent implements OnInit {

  message: string = "";
  fileList: FileList = null;
  readonly rootUrl = AppSettings.webApiURL; 

  constructor(public httpClient: HttpClient) { }

  ngOnInit() {
  }


  fileChange(event) {
    this.fileList = event.target.files;
    this.message = "";
  }


  fileUploadOperation(isFullLoading) {
    //let fileList: FileList = event.target.files;
    this.message = "";

    if(this.fileList && this.fileList.length > 0) 
    {
        let file: File = this.fileList[0];
        let formData:FormData = new FormData();
        formData.append('uploadFile', file, file.name);
        formData.append('isFullLoading', isFullLoading);
        
        var reqHeader = new HttpHeaders(
          {
            //'Content-Type': 'multipart/form-data',
            'Accept': 'application/json'
          });
        this.httpClient.post(`${this.rootUrl}/api/CustomerRefresh/UploadCustomers`, formData, { headers: reqHeader })
            .subscribe((response: any) => {
              if (response.startsWith("תקלה:"))
              {
                alert(response);
              }
              else
              {
                this.message = response; 
              }
            }, 
            (err: any) => {
              alert(err.error.ExceptionMessage);
            });
    }
    else
    {
        alert('יש לבחור קובץ');
    }
 }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/customer-refresh/customer-refresh.component.ts